export default "__VITE_ASSET__DMcGhw$V__"